import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import { FaPlus } from "react-icons/fa";
import AddonField from "./AddonField";
import FieldConditionEditor from "./FieldConditions";

const AddonModalForm = ({
  isOpen,
  toggle,
  originalRow,
  onSave,
  addonsList,
}) => {
  const [newRow, setNewRow] = useState({
    productmeta_id: "new",
    productmeta_name: "",
    the_meta: {},
  });

  useEffect(() => {
    setNewRow(originalRow);
  }, [originalRow]);

  const generateDataName = (title) =>
    title
      .toLowerCase()
      .replace(/[^a-z0-9 ]/g, "")
      .replace(/\s+/g, "_");

  const handleMetaChange = (index, key, value) => {
    setNewRow((prev) => {
      const currentMeta = prev.the_meta[index] || {};
      const updatedFields = {
        ...currentMeta,
        [key]: value,
      };

      if (key === "title") {
        updatedFields.data_name = generateDataName(value);
      }

      //   console.log(updatedFields);

      return {
        ...prev,
        the_meta: {
          ...prev.the_meta,
          [index]: updatedFields,
        },
      };
    });
  };

  const addMetaField = () => {
    const newIndex = Object.keys(newRow.the_meta).length + 1;
    setNewRow((prev) => ({
      ...prev,
      the_meta: {
        ...prev.the_meta,
        [newIndex]: {
          title: "",
          is_required: false,
          is_multiple: false,
          options: [],
          type: "radio",
          visibility_condition: {
            field: "",
            value: "",
          },
        },
      },
    }));
  };

  const removeMetaField = (index) => {
    const updatedMeta = { ...newRow.the_meta };
    delete updatedMeta[index];
    setNewRow((prev) => ({ ...prev, the_meta: updatedMeta }));
  };

  const addOption = (index) => {
    const generateId = () =>
      `opt_${Date.now()}_${Math.floor(Math.random() * 1000)}`;

    setNewRow((prev) => ({
      ...prev,
      the_meta: {
        ...prev.the_meta,
        [index]: {
          ...prev.the_meta[index],
          options: [
            ...(prev.the_meta[index].options || []),
            { id: generateId(), option: "", price: "", color: "#000000" },
          ],
        },
      },
    }));
  };

  const removeOption = (index, optionIndex) => {
    setNewRow((prev) => ({
      ...prev,
      the_meta: {
        ...prev.the_meta,
        [index]: {
          ...prev.the_meta[index],
          options: prev.the_meta[index].options.filter(
            (_, i) => i !== optionIndex
          ),
        },
      },
    }));
  };

  const handleOptionChange = (index, optionIndex, key, value) => {
    const updatedOptions = [...(newRow.the_meta[index].options || [])];
    updatedOptions[optionIndex][key] = value;
    setNewRow((prev) => ({
      ...prev,
      the_meta: {
        ...prev.the_meta,
        [index]: {
          ...prev.the_meta[index],
          options: updatedOptions,
        },
      },
    }));
  };

  const handleCancel = () => {
    setNewRow({
      productmeta_id: "new",
      productmeta_name: "",
      the_meta: {},
    });
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Add/Edit Addon</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <h6 className="fw-bold mb-3 d-flex justify-content-between">
              Name
              <Button color="primary" size="sm" onClick={addMetaField}>
                <FaPlus /> Add Field
              </Button>
            </h6>
            <Input
              type="text"
              id="productmeta_name"
              value={newRow.productmeta_name}
              onChange={(e) =>
                setNewRow((prev) => ({
                  ...prev,
                  productmeta_name: e.target.value,
                }))
              }
              placeholder="Enter Addon Name"
              className="mb-3"
            />
          </FormGroup>

          {Object.entries(newRow.the_meta).map(([index, meta]) => (
            <div className="border rounded">
              <AddonField
                key={index}
                index={index}
                meta={meta}
                onChange={handleMetaChange}
                onRemoveField={removeMetaField}
                onAddOption={addOption}
                onRemoveOption={removeOption}
                onOptionChange={handleOptionChange}
              />

              <FieldConditionEditor
                index={index}
                meta={meta}
                allFields={addonsList}
                onConditionChange={(idx, newCondition) =>
                  handleMetaChange(idx, "visibility_condition", newCondition)
                }
              />
            </div>
          ))}
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={() => onSave(newRow)}>
          Save
        </Button>
        <Button color="danger" onClick={handleCancel}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddonModalForm;
